import React, { useLayoutEffect, useRef } from 'react';
import { ReactComponent as LineSvg } from "./images/Line.svg";
import { ReactComponent as Ellipse1Svg } from "./images/Ellipse1.svg";
import { gsap } from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

const AnimateLine = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const animations = useRef<gsap.core.Tween[]>([]);
	
	useLayoutEffect(() => {
		const communityLinePath = document.getElementById(
			"community-line-path"
		) as SVGPathElement | null;
		
		if (!communityLinePath) {
			console.error("Path with id 'community-line-path' not found");
			return;
		}
		
		const communityEllipse1 = document.getElementById(
			"community-ellipse-1"
		) as SVGElement | null;
		
		const communityEllipse2 = document.getElementById(
			"community-ellipse-2"
		) as SVGElement | null;
		
		const communityEllipse3 = document.getElementById(
			"community-ellipse-3"
		) as SVGElement | null;
		
		if (communityEllipse1) {
			const animation1 = gsap.to(communityEllipse1, {
				duration: 15,
				motionPath: {
					path: communityLinePath,
					align: communityLinePath,
					alignOrigin: [0.5, 0.5],
					autoRotate: true,
				},
				repeat: -1,
				ease: 'none',
				opacity: 1,
			});
			animations.current.push(animation1);
		}
		
		if (communityEllipse2) {
			const animation2 = gsap.to(communityEllipse2, {
				duration: 15,
				motionPath: {
					path: communityLinePath,
					align: communityLinePath,
					alignOrigin: [0.5, 0.5],
					autoRotate: true,
				},
				repeat: -1,
				ease: 'none',
				opacity: 0,
				delay: 5,
			});
			animations.current.push(animation2);
		}
		
		if (communityEllipse3) {
			const animation3 = gsap.to(communityEllipse3, {
				duration: 15,
				motionPath: {
					path: communityLinePath,
					align: communityLinePath,
					alignOrigin: [0.5, 0.5],
					autoRotate: true,
				},
				repeat: -1,
				ease: 'none',
				opacity: 0,
				delay: 10,
			});
			animations.current.push(animation3);
		}
		
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					animations.current.forEach((animation) => animation.play());
				} else {
					animations.current.forEach((animation) => animation.pause());
				}
			},
			{ threshold: 0.1 }
		);
		
		if (containerRef.current) {
			observer.observe(containerRef.current);
		}
		
		return () => {
			observer.disconnect();
			animations.current.forEach((animation) => animation.kill());
		};
	}, []);
	
	return (
		<div className="animateLine" ref={containerRef}>
			<LineSvg />
			<Ellipse1Svg id="community-ellipse-1" className="ellipse" />
			<Ellipse1Svg id="community-ellipse-2" className="ellipse" />
			<Ellipse1Svg id="community-ellipse-3" className="ellipse" />
		</div>
	);
};

export default AnimateLine;